import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { FooterComponent } from 'src/app/components/footer/footer.component';
import { AnimatedBackgroundComponent } from 'src/app/components/animated-background/animated-background.component';
import { NavButtonsComponent } from 'src/app/components/nav-buttons/nav-buttons.component';
import { ProgressBarComponent } from 'src/app/components/progress-bar/progress-bar.component';
import { QuestionButtonsComponent } from 'src/app/components/question-buttons/question-buttons.component';
import { FooterTextComponent } from 'src/app/components/footer-text/footer-text.component';
import { QuestionInputComponent } from 'src/app/components/question-input/question-input.component';
import { QuestionDropdownComponent } from 'src/app/components/question-dropdown/question-dropdown.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule } from 'src/app/material.module';
import { TooltipDialogComponent } from 'src/app/components/tooltip-dialog/tooltip-dialog.component';
import { BaseModalComponent } from 'src/app/components/modal/base-modal/base-modal.component';
import { CompTpftModalComponent } from 'src/app/components/modal/comp-tpft-modal/comp-tpft-modal.component';
import { ConfirmModalComponent } from 'src/app/components/modal/confirm-modal/confirm-modal.component';
import { EditDriversModalComponent } from 'src/app/components/modal/edit-drivers-modal/edit-drivers-modal.component';
import { ResultModalComponent } from 'src/app/components/modal/result-modal/result-modal.component';
import { KbcUlsterModalComponent } from 'src/app/components/modal/kbc-ulster-modal/kbc-ulster-modal.component';
import { KmCalculatorModalComponent } from 'src/app/components/modal/km-calculator-modal/km-calculator-modal.component';
import { XSellRenewalModalComponent } from 'src/app/components/modal/xsell-renewal-modal/xsell-renewal-modal.component';
import { HtmlSanitizePipe } from 'src/app/pipes/html-sanitize.pipe';
import { OneCurrencyPipe } from 'src/app/pipes/one-currency.pipe';
import { QuestionDateComponent } from 'src/app/components/question-date/question-date.component';
import { QuestionEditDropdownComponent } from 'src/app/components/question-edit-dropdown/question-edit-dropdown.component';
import { JenHelpSectionComponent } from 'src/app/components/jen-help-section/jen-help-section.component';
import { BigEuroComponent } from 'src/app/components/big-euro/big-euro.component';
import { DobFormatDirective } from 'src/app/directives/dob-format.directive';
import { OneCurrencyEuroPipe } from 'src/app/pipes/one-currency-euro.pipe';
import { SafeResourcePipe } from 'src/app/pipes/safe-resource.pipe';
import { QuestionCheckboxComponent } from 'src/app/components/question-checkbox/question-checkbox.component';
import { AutofocusDirective } from 'src/app/directives/autofocus.directive';
import { UnloadBrowserNotificationDirective } from 'src/app/directives/unload-browser-notification.directive';
import { TimerComponentComponent } from 'src/app/components/timer-component/timer-component.component';
import { DropdownEventDirective } from 'src/app/directives/dropdown-event.directive';
import { CaptchaErrorComponent } from 'src/app/pages/error/captcha-error/captcha-error.component';
import { StepperBarComponent } from 'src/app/components/stepper-bar/stepper-bar.component';
import { QuestionDateExpiryComponent } from 'src/app/components/question-date-expiry/question-date-expiry.component';
import { BackNavButtonComponent } from 'src/app/components/back-nav-button/back-nav-button.component';
import { ExtendableCardComponent } from 'src/app/components/extendable-card/extendable-card.component';
import { InfoCardComponent } from 'src/app/components/info-card/info-card.component';
import { SelectProductTypesComponent } from 'src/app/pages/select-product/select-product-types/select-product-types.component';
import { DriverLicenceModalComponent } from 'src/app/components/modal/driver-licence-modal/driver-licence-modal.component';
import { MtplConfirmModalComponent } from 'src/app/components/modal/mtpl-confirm-modal/mtpl-confirm-modal.component';
import { ConfirmChangeProductComponent } from 'src/app/components/modal/confirm-change-product/confirm-change-product.component';
import { QuoteContainerComponent } from 'src/app/components/quote-container/quote-container.component';
import { XsellInlineAlertComponent } from 'src/app/components/xsell-inline-alert/xsell-inline-alert.component';
import { InLineAlertComponent } from 'src/app/components/in-line-alert/in-line-alert.component';
import { CarRegReminderModalComponent } from 'src/app/components/modal/car-reg-reminder-modal/car-reg-reminder-modal.component';
import { LoadingIndicatorComponent } from 'src/app/components/loaders/loading-indicator/loading-indicator.component';
import { QuoteSpinLoaderComponent } from 'src/app/components/loaders/quote-spin-loader/quote-spin-loader.component';
import { LoadingComponent } from 'src/app/components/loading-spinner/loading.component';

export const componentDeclaraions: any[] = [
    /* shared components */
    AnimatedBackgroundComponent,
    FooterComponent,
    FooterTextComponent,
    NavButtonsComponent,
    ProgressBarComponent,
    TooltipDialogComponent,
    JenHelpSectionComponent,
    LoadingIndicatorComponent,
    QuoteSpinLoaderComponent,
    TimerComponentComponent,
    CaptchaErrorComponent,
    StepperBarComponent,
    LoadingComponent,
    BackNavButtonComponent,
    ExtendableCardComponent,
    InfoCardComponent,

    /* Input components */
    QuestionButtonsComponent,
    QuestionInputComponent,
    QuestionDropdownComponent,
    QuestionDateComponent,
    QuestionEditDropdownComponent,
    QuestionCheckboxComponent,
    QuestionDateExpiryComponent,

    /* Modal Components */
    ResultModalComponent,
    ConfirmModalComponent,
    CompTpftModalComponent,
    EditDriversModalComponent,
    BaseModalComponent,
    KbcUlsterModalComponent,
    KmCalculatorModalComponent,
    XSellRenewalModalComponent,
    DriverLicenceModalComponent,
    MtplConfirmModalComponent,
    ConfirmChangeProductComponent,
    CarRegReminderModalComponent,

    /* Pipes Components */
    HtmlSanitizePipe,
    OneCurrencyPipe,
    BigEuroComponent,
    OneCurrencyEuroPipe,
    SafeResourcePipe,

    /* Directive Components */
    DobFormatDirective,
    UnloadBrowserNotificationDirective,
    AutofocusDirective,
    DropdownEventDirective,

    /* Common Components */
    SelectProductTypesComponent,
    QuoteContainerComponent,
    XsellInlineAlertComponent,
    InLineAlertComponent
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        AngularMaterialModule,
        NgOptimizedImage,
    ],
    exports: [

        NgOptimizedImage
    ]
})
export class SharedModule { }
